import * as React from "react";
import { IconButton, styled } from "@mui/material";
import { ReactComponent as GraphIcon } from "../../../assets/graphIcon.svg";
import { QualifiedFeature } from "fe-common/graphql";
import { InChatReasoningButtonBadge } from "./inChatDemoReasoningIcon";
import { PatientColorMap } from "../../../layout/patientColorMap";
import { usePatientFeatureFlags } from "../../../hooks/usePatientFeatureFlags";

//region [[ Styles ]]

const ShowGraphButtonView = styled("div")({
  display: "flex",
  flexFlow: "column",
  justifyContent: "center",
  alignItems: "center",
});

const ShowGraphIconContainer = styled(IconButton)({
  width: "23px",
  height: "23px",
  "&.show-graph-icon, &.show-graph-icon:hover, &.show-graph-icon:focus": {
    padding: 0,
    margin: "5px",
  },
  "& svg": {
    width: "15px",
    height: "15px",
  },
});

const ShowGraphButtonText = styled(InChatReasoningButtonBadge)({
  "&.reasoning-text, &.reasoning-text:hover, &.reasoning-text:active, &.reasoning-text:focus": {
    color: PatientColorMap.White,
    background: PatientColorMap.DefaultDark,
  },
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface ShowGraphButtonProps {
  onClick: (qf: QualifiedFeature) => void;
  qf: QualifiedFeature;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ShowGraphButton = ({ ...props }: ShowGraphButtonProps) => {
  const buildGraphSelection = () => {
    props.onClick(props.qf);
  };

  const isDemoPane = usePatientFeatureFlags("demoPane") as boolean;

  if (!isDemoPane) return null;

  return (
    <ShowGraphButtonView>
      <ShowGraphIconContainer
        className={"show-graph-icon"}
        onClick={buildGraphSelection}
      >
        <GraphIcon />
      </ShowGraphIconContainer>
      <ShowGraphButtonText className={"reasoning-text"}>
        See Reasoning Graph
      </ShowGraphButtonText>
    </ShowGraphButtonView>
  );
};
